<script>
  import { Swiper, SwiperSlide } from "swiper/svelte";
  import SwiperCore, { Navigation } from "swiper";
  import { onMount } from "svelte";
  import EventCard from "../EventCard/EventCard.svelte";
  import ErrorMessage from "../ErrorMessage/ErrorMessage.svelte";
  import IconButton from "../IconButton/IconButton.svelte";
  import Skeleton from "../Skeleton/Skeleton.svelte";
  import ArrowIcon from "../../icons/arrow.svg";
  import { t } from '../../i18n';
  import "swiper/swiper-bundle.min.css";

  SwiperCore.use([Navigation]);

  let events = [];
  let error = false;
  let loading = true;

  async function fetchEvents() {
    try {
      const eventsRequest = await fetch(`${API_URL}/events`);
      if (eventsRequest.status === 200) {
        const data = await eventsRequest.json();
        events = data.results;
        loading = false;
      } else {
        throw new Error("API returned unexpected status.");
      }
    } catch (e) {
      console.log(e);
      error = true;
      loading = false;
    }
  }

  onMount(async () => {
    fetchEvents();
  });
</script>

<style>
  .c-event-carousel__wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--neutral-050);
    padding: 32px 20px 8px;
  }

  @media (max-width: 768px) {
    .c-event-carousel__wrapper {
      padding: 32px 12px 8px;
    }
  }

  .c-event-carousel__wrapper :global(.swiper-slide) {
    height: auto;
    padding: 8px 0 32px;
  }

  .c-event-carousel__width-wrapper {
    max-width: 100%;
    width: 1160px;
    min-width: 0;
  }

  .c-event-carousel__button-wrap--prev {
    margin-right: 46px;
  }
  .c-event-carousel__button-wrap--next {
    margin-left: 46px;
  }
  .c-event-carousel__button-wrap--next :global(svg) {
    transform: rotate(180deg);
  }

  @media (max-width: 768px) {
    .c-event-carousel__button-wrap--prev {
      margin-right: 12px;
    }
    .c-event-carousel__button-wrap--next {
      margin-left: 12px;
    }
  }
</style>

<div class="c-event-carousel__wrapper">
  {#if !error}
    {#if loading}
      <Skeleton />
    {:else if events.length === 0}
      <ErrorMessage message={$t('error_state_no_events')}/>
    {:else}
      <div
        class="c-event-carousel__button-wrap c-event-carousel__button-wrap--prev">
        <IconButton className="c-event-carousel__prev-slide">
          <ArrowIcon width="8" />
        </IconButton>
      </div>
      <div class="c-event-carousel__width-wrapper">
        <Swiper
          observer={true}
          spaceBetween={1}
          slidesPerView={1}
          centerInsufficientSlides={true}
          breakpoints={{ 1160: { slidesPerView: 3 }, 768: { slidesPerView: 2 } }}
          pagination={{ clickable: true }}
          navigation={{ nextEl: `.c-event-carousel__next-slide`, prevEl: `.c-event-carousel__prev-slide` }}>
          {#each events as event}
            <SwiperSlide style={{ height: 'auto', padding: '3px 0' }}>
              <EventCard {...event} />
            </SwiperSlide>
          {/each}
        </Swiper>
      </div>
      <div
        class="c-event-carousel__button-wrap c-event-carousel__button-wrap--next">
        <IconButton className="c-event-carousel__next-slide">
          <ArrowIcon width="8" />
        </IconButton>
      </div>
    {/if}
  {:else}
    <p>{$t('generic_error')}</p>
  {/if}
</div>
